 <template>
  <el-row class="el-row_h">
    <el-col :span="24">
      <div class="grid-content bg-purple-dark layout_box flex s_bg" style="overflow: auto">
        <el-select style="min-width: 150px;" v-model="UserCode" size="small" clearable filterable :filter-method="remoteMethod" placeholder="请选择用户" class="s_padding">
          <el-option v-for="item in displaylists" :key="item.UserCode" :label="item.UserName" :value="item.UserCode">
          </el-option>
        </el-select>
        <el-date-picker style="min-width: 150px;" v-model="Dateval" :picker-options="pickerOptions" size="small" class="s_padding" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
        </el-date-picker>
        <el-button type="primary" icon="el-icon-search" size="small" @click="getList()">查询</el-button>
      </div>
      <div style="height: 100%; overflow: auto">
        <tableCom :tableData="tableData" v-loading="loading"></tableCom>
      </div>
    </el-col>
  </el-row>
</template>
<script>
import CommonJs from "@/assets/js/Common.js";
import tableCom from "./StatisticsProfitT.vue";
import pagination from "../../../paging.vue";
import dateRange from "../../../dateRangeSub.vue";

export default {
  // 结算单
  name: "positionDetailS",
  components: {
    tableCom,
    pagination,
    dateRange
  },
  props: ["agentID"],
  data() {
    return {
      loading: "",
      Pager: {
        PageNo: 1,
        PageSize: 10000,
        RecordCount: 0
      },
      tableData: {
        ishow: true,
        isShow1: false,
        isShow2: false,
        isShow3: false,
        isShow4: false,
        itemCounts1: "0",
        itemCounts2: "0",
        itemCounts3: "0",
        itemCounts4: "0",
        UserAccounts: {},

        billData: {}
      },
      totalCapital: 0,
      totalCurrency: 0,
      Dateval: "",
      UserList: [],
      UserCode: "",
      cacheUserList: [],
      displaylists: [],
      pickerOptions: {
      }
    };
  },
  created() {
    // 获取结算单日期范围
    this.GetInsConfigParam();
  },
  mounted() {
    this.Dateval = CommonJs.getNowFormatDate();
    this.getallUser();
  },
  methods: {
    GetInsConfigParam() {
      let url = "/common/GetInsConfigParam";
      let postData = 'GetBalanceBillDate';
      this.$loginapi.post(url, postData, response => {
        if (response.Ret == 0) {
           this.pickerOptions.disabledDate = function (time) {
              var today = new Date();
              var day = response.Data.Value;
              if (day > 0) {
                day = day * -1;
              }
              var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
              return (time.getTime() > Date.now()) || (time.getTime() < targetday_milliseconds);
           }
        } else {
          // this.$message.error(response.Msg);
        }
      });
    },
    getallUser() {
      let UserCode = JSON.parse(sessionStorage.getItem("userInfo")).AccountCode;
      let url = "/subagent/QueryUsersByAgent";
      this.$loginapi.postWithPage(url, 1, 10000, UserCode, response => {
        if (response.Ret == 0) {
          if(response.Data.length == 0){
              this.$message.warning("暂无用户");
              return;
          }else{
            this.UserList = response.Data;
            this.displaylists = jQuery.extend([], this.UserList);
            this.cacheUserList = jQuery.extend([], this.UserList);
            this.UserCode = this.UserList[0].UserCode;
            // this.getList();            
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    getList() {
      if(this.UserCode == ""){
        this.$message.warning("请选择用户");
        return;
      }
      if(this.Dateval == "" || this.Dateval == null){
        this.$message.warning("请选择时间");
        return;
      }
      this.loading = true;
      let url = "/report/QryTradeBalanceBill";
      let postData = {
        UserCode: this.UserCode,
        Date: this.Dateval
      };
      this.$loginapi.post(url, postData, response => {
        this.loading = false;
        if (response.Ret == 0) {
          if (response.Data != null) {
            this.tableData.ishow = false;
            this.tableData.billData = response.Data;
            let arrA = [];
            let b = "";

            this.tableData.billData.Trades.forEach(element => {
              element.CloseVolume > 0 ? arrA.push(element) : (b = "0");
            });
            this.tableData.billData.ClosePositionDetail = arrA;

            this.tableData.isShow1 =
              this.tableData.billData.PositionDetails.length > 0 ? true : false;
            this.tableData.isShow2 =
              this.tableData.billData.PositionStatis.length > 0 ? true : false;
            this.tableData.isShow3 =
              this.tableData.billData.Trades.length > 0 ? true : false;
            this.tableData.isShow4 =
              this.tableData.billData.ClosePositionDetail.length > 0
                ? true
                : false;
            this.tableData.itemCounts1 = this.tableData.billData.PositionDetails.length;
            this.tableData.itemCounts2 = this.tableData.billData.PositionStatis.length;
            this.tableData.itemCounts3 = this.tableData.billData.Trades.length;
            this.tableData.itemCounts4 = this.tableData.billData.ClosePositionDetail.length;
            this.tableData.UserAccounts = this.tableData.billData.UserAccounts[0];
          } else {
            this.tableData.billData = {};
            this.tableData.ishow = true;
          }
        } else {
          this.$message.error(response.Msg);
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        setTimeout(() => {
          this.displaylists = this.cacheUserList.filter(item => {
            return (
              item.UserName.toLowerCase().indexOf(query.toLowerCase()) > -1
            );
          });
        }, 200);
      } else {
        this.displaylists = jQuery.extend([], this.UserList);
        this.UserCode = "";
      }
    },
    pageFn(size, PageNo) {
      this.Pager.PageSize = size;
      this.Pager.PageNo = PageNo;
      this.getList(false);
    }
  }
};
</script>

<style scoped>
.pagination_m {
  /* bottom: 20px !important; */
}
</style>



// WEBPACK FOOTER //
// src/components/selects/statics/StatisticsProfit/StatisticsProfitS.vue